<mat-form-field appearance="outline" floatLabel="always">
  <mat-select [formControl]="control" [compareWith]="compareOptions">
    <mat-option *ngFor="let option of salesReps$ | async" [value]="option">
      {{ option.name }} ({{ option.number }})
    </mat-option>
  </mat-select>
</mat-form-field>
